import { createContext, useContext, useId } from "react";
import { isWeb, withStaticProperties } from "@tamagui/core";
import { Box } from "../Box";
import { Button } from "../Button";
import { jsx } from "react/jsx-runtime";
const FormContext = createContext({ onSubmit: () => {
}, formId: "" }), FormProvider = ({ onSubmit, formId, children }) => {
  const backupId = useId(), id = formId || backupId;
  return /* @__PURE__ */ jsx(FormContext.Provider, { value: { onSubmit, formId: id }, children });
}, FormComponent = ({ children, ...props }) => {
  const { onSubmit, formId } = useContext(FormContext);
  return /* @__PURE__ */ jsx(
    Box,
    {
      tag: "form",
      id: formId,
      onSubmit: isWeb ? onSubmit : void 0,
      ...props,
      children
    }
  );
}, FormButton = (props) => {
  const { onSubmit, formId } = useContext(FormContext);
  return /* @__PURE__ */ jsx(
    Button,
    {
      type: "submit",
      form: isWeb ? formId : void 0,
      onPress: isWeb ? void 0 : (event) => {
        onSubmit(event);
      },
      ...props
    }
  );
}, Form = withStaticProperties(FormProvider, {
  Form: FormComponent,
  Button: FormButton
});
export {
  Form
};
